import React from "react";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../../hooks";

import './ExchangeRates.sass'



const ExchangeRates = () => {
    const { t } = useTranslation();
    const rate = useAppSelector<number>(state => state.rate.value)
    const balance = useAppSelector<number>(state => state.user.value.balance)
    const currUser = useAppSelector((state) => state.user.value);
    const location = process.env.REACT_APP_LOCATION ?? 'ua';

    return (
        <div className={"exchange_rate-wrapper"}>
            <div className={location == 'ua' ? "balance_wrapper" : "balance_wrapper border-full"}>{t('balance')} <span className={balance > 0 ? "red" : "green"}> {Number(-balance).toFixed(2)} {t(currUser.currency)}</span></div>
            {location == 'ua'? <div className={"rate_wrapper"}>{t('exchangeRates')} <span>$ {rate}</span></div> : null}
        </div>

    )
}
export default ExchangeRates;